import React, { useMemo, useContext, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const CustomerActivityDetails = () => {
  const { activityId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const [showDelete, setShowDelete] = useState(false);

  const decodedId = activityId ? atob(activityId) : activityId;
  const id = decodedId ? decodedId.replace(/\D/g, '') : '';
  const url = id ? `${API_DOMAIN}${API_ROUTES.customerActivity}${id}/` : null;
  const { data: activity, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!activity) return [];
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(activity)
      .filter(k => !excluded.includes(k))
      .map(k => ({ label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' '), field: k }));
  }, [activity]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.customerActivity}${id}/`);
      showToast('Activity deleted successfully', 'success');
      setShowDelete(false);
      navigate('/customer/activity/list');
    } catch (error) {
      console.error('Error deleting activity:', error);
      showToast('Error deleting activity', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={activity}
        columns={columns}
        loading={loading}
        entityName="Activity"
        listPath="/customer/activity/list"
        editPath={`/customer/activity/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
        title="Delete Activity"
        message="Are you sure you want to delete this activity?"
      />
    </div>
  );
};

export default CustomerActivityDetails;
